export default "__VITE_ASSET__CbzAnjGP__"